import { FC, useState, MutableRefObject, useRef } from 'react';
import { ProDrawer } from '../../../antd';
import SearchForm from '../../../SearchForm';
import useSearchForm from '../../hooks/useSearchForm';
import { SearchFormProps } from '../../../SearchForm/searchForm';
import { SuperFormItemProps } from '../../interface';
import { FormInstance } from 'antd/lib/form';

export interface HighSearchAction {
  show: () => void;
  hide: () => void;
  form?: FormInstance;
}

interface HighSearchProps extends Omit<SearchFormProps, 'actionRef'> {
  highWidth?: number;
  actionRef: MutableRefObject<HighSearchAction | undefined>;
  formItems: SuperFormItemProps[];
  onFinish: (values: any) => void;
}

const HighSearch: FC<HighSearchProps> = props => {
  const { actionRef, formItems, highWidth, onFinish, ...restProps } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const renderChildren = useSearchForm(formItems);
  const searchFormAction = useRef<FormInstance>();
  /** 显示 */
  const handleShow = () => {
    setVisible(true);
  };
  /** 隐藏 */
  const handleHide = () => {
    setVisible(false);
  };
  /** 搜索 */
  const handleFinish = (values: any) => {
    setVisible(false);
    onFinish(values);
  };
  actionRef.current = {
    show: handleShow,
    hide: handleHide,
    form: searchFormAction.current,
  };
  return (
    <ProDrawer
      open={visible}
      title="高级搜索"
      placement="right"
      onClose={handleHide}
      width={highWidth}
      forceRender={true}
    >
      <SearchForm
        {...restProps}
        defaultLineNumber={1}
        defaultLabelCol={{ span: 8 }}
        actionRef={searchFormAction}
        onFinish={handleFinish}
      >
        {renderChildren}
        <SearchForm.Operation hideReset />
      </SearchForm>
    </ProDrawer>
  );
};

HighSearch.defaultProps = {
  highWidth: 360,
};

export default HighSearch;
